const CONFIG = {
    BASE: 'https://api-staging.clento.ai',
};

export default CONFIG;
